import { useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const S = {
  page: { minHeight: '100vh', background: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', fontFamily: "'Inter', sans-serif" },
  card: { width: '100%', maxWidth: '480px', background: '#111', border: '1px solid #222', borderRadius: '8px', padding: '2.5rem' },
  title: { color: '#e0e0e0', fontSize: '1.3rem', fontWeight: 600, marginBottom: '0.4rem', fontFamily: "'Merriweather', serif" },
  subtitle: { color: '#bbb', fontSize: '0.88rem', marginBottom: '2rem', lineHeight: '1.6' },
  label: { display: 'block', color: '#bbb', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.35rem' },
  input: { width: '100%', background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: '4px', color: '#e0e0e0', padding: '0.65rem 0.8rem', fontSize: '0.95rem', boxSizing: 'border-box', marginBottom: '1.2rem', outline: 'none' },
  btn: { width: '100%', background: '#8B1A1A', color: '#fff', border: 'none', borderRadius: '4px', padding: '0.75rem', fontSize: '0.95rem', fontWeight: 600, cursor: 'pointer', letterSpacing: '0.04em' },
  btnDisabled: { opacity: 0.5, cursor: 'not-allowed' },
  error: { color: '#e74c3c', fontSize: '0.85rem', marginBottom: '1rem' },
  success: { color: '#4caf50', fontSize: '0.95rem', marginBottom: '1rem' },
}

export default function Register() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const email = searchParams.get('email')
  const { register } = useAuth()
  const navigate = useNavigate()
  const [fullName, setFullName] = useState('')
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState('')

  const valid = fullName.trim().length > 1

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!valid) return
    setStatus('submitting')
    setError('')
    try {
      await register(token, email, fullName.trim())
      navigate('/nda')
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. This invitation may be invalid or expired.')
      setStatus('idle')
    }
  }

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.title}>Create Your Account</div>
        <div style={S.subtitle}>
          You have been invited to access the Menhaden Policy Research database. Please provide your full name to complete registration.
        </div>

        {error && <div style={S.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <label style={S.label}>Full Name *</label>
          <input
            style={S.input}
            type="text"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            required
            autoFocus
            autoComplete="name"
            placeholder="First and Last Name"
          />

          <button
            type="submit"
            style={{ ...S.btn, ...((!valid || status === 'submitting') ? S.btnDisabled : {}) }}
            disabled={!valid || status === 'submitting'}
          >
            {status === 'submitting' ? 'Creating account...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  )
}
